module.exports = __webpack_public_path__ + "img/line-graph-icon.c7ad7510.png";